type Row = Record<string, unknown>;
export type ForcedMovement = { abilityId: string; targetId: string; start: { x: number; y: number; z: number };
  end: { x: number; y: number; z: number }; delta: { x: number; y: number; z: number } };

/** The same saved movement result for direct uses and their zone/loss/support consequence frames. */
export function forcedMovementResults(abilityId: string, movedIds: readonly string[], ec: Record<string, Row>, memberBefore: Record<string, Row>): ForcedMovement[] {
  return movedIds.map(id => {
    const before = memberBefore[id], changes = ec[id];
    if (!before || !changes) return null;
    const start = { x: Number(before.x_pos), y: Number(before.y_pos), z: Number(before.z_pos) };
    const end = { x: Number(changes.x_pos ?? start.x), y: Number(changes.y_pos ?? start.y), z: Number(changes.z_pos ?? start.z) };
    return { abilityId, targetId: id, start, end, delta: { x: end.x - start.x, y: end.y - start.y, z: end.z - start.z } };
  }).filter((value): value is ForcedMovement => value !== null);
}
